import React, { memo } from "react";

function ContactUs() {
  return <p>Contact Us</p>;
}

export default memo(ContactUs);
